module.exports = __webpack_public_path__ + "static/media/home-xuanshangzhaopin.17101cdb.png";